// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"e72415a6","742":"d9c97cd6"}[chunkId] + ".chunk.js";
};